export default {
  common: {
    attention: 'Atenção',
    error: 'Erro',
    success: 'Sucesso',
    continue: 'Avançar',
    understood: 'ENTENDI!',
    backToLogin: 'Voltar para o login',
    please: 'Por favor:',
  },
  login: {
    password: 'Senha',
    cpf: 'CPF',
    email: 'E-mail',
    loginWith: 'Entrar com:',
    logWith: 'Logar com:',
    forgotPassword: 'Esqueceu sua senha?',
    noAccount: 'Não possui conta?',
    noAccountYet: 'Ainda não possui conta?',
    switchToEmail: 'Alternar para Email',
    switchToCpf: 'Alternar para CPF',
    register: 'Cadastre-se',
    createAccount: 'CRIAR CONTA',
  },
  cadastro: {
    iAgreeWith: 'Concordo com os',
    termsOfUse: 'Termos de Uso e Política de Privacidade',
    fromThisSite: 'deste site.',
    acceptTermsPrivacy: 'Aceite termos de uso e privacidade',
    termsOfUsePrivacy: 'Termos de uso e privacidade',
    requiredField: 'Obrigatório',
    optinLoadError:
      'Volte e tente novamente, ou entre em contato com o suporte. Ocorreu o seguinte erro: {error}',
    waitRegisteringYourAccount:
      'Aguarde, estamos cadastrando sua conta. Isso poderá levar alguns segundos.',
    accountCreationMessage: 'Cadastro efetuado com sucesso!',
    accountCreationMessageError: 'Não foi possível criar sua conta.',
    accountCreationMessageNetworkError: 'Erro de rede: Verifique sua conexão com a internet.',
    requiredTerms: 'É necessário aceitar todos os termos obrigatórios.',
    requiredTermsTitle: 'Termos Obrigatórios',
  },
  cpfVerification: {
    placeholder: 'Insira seu CPF',
    notInBrazil: 'Não moro no Brasil',
    cpfEmailAssociated:
      'Seu CPF e seu e-mail já estão associados a uma conta.<br />Para continuar, insira o código de verificação enviado para o e-mail cadastrado.',
    verificationCodePlaceholder: 'Insira o código de verificação recebido',
    cpfRequired: 'É necessário informar seu CPF.',
    cpfInvalid: 'Informe um CPF válido.',
  },
  country: {
    label: 'Em qual país você mora?',
    loadError: 'A busca da lista de países falhou.',
    required: 'É necessário informar o país.',
  },
  passport: {
    placeholder: 'Passaporte',
    required: 'É necessário informar o passaporte.',
    invalid: 'Informe um passaporte válido.',
  },
  birthDate: {
    placeholder: 'Data de nascimento (dd/mm/aaaa)',
    required: 'É necessário informar sua data de nascimento.',
    invalid: 'Informe uma data de nascimento válida.',
    minimumAge: 'Cadastro permitido apenas para maiores de {age}.',
  },
  gender: {
    identity: 'Identidade de gênero',
    male: 'Masculino',
    female: 'Feminino',
    other: 'Outro',
    required: 'É necessário informar seu gênero.',
  },
  name: {
    firstName: 'Nome',
    fullName: 'Nome completo',
    surname: 'Sobrenome',
    fullNameRequired: 'É necessário informar seu nome completo.',
    firstNameRequired: 'É necessário informar seu nome.',
    surnameRequired: 'É necessário informar o seu sobrenome.',
    socialNameRequired: 'É necessário informar como gostaria de ser chamado(a).',
    beCalled: 'Como gostaria de ser chamado(a)?',
  },
  cpfAndPhone: {
    cpfInvalid: 'Informe um CPF válido.',
    phoneRequired: 'É necessário informar um telefone.',
    phoneInvalid: 'Informe um telefone válido.',
    phoneInternationalInvalid: 'Informe um telefone internacional válido.',
  },
  email: {
    placeholder: 'E-mail',
    confirmPlaceholder: 'Confirme seu E-mail',
    verificationCode: 'Insira o código de verificação recebido',
    required: 'É necessário informar um e-mail.',
    invalid: 'Informe um e-mail válido.',
    mismatch: 'Os e-mails informados são diferentes.',
    codeRequired: 'É necessário informar o código de verificação.',
    codeInvalid: 'Código informado incorreto.',
  },
  phone: {
    mobile: 'Celular',
    ddi: 'DDI*',
    areaCode: 'DDD*',
    yourPhone: 'Seu telefone*',
    required: 'É necessário informar um telefone.',
    invalid: 'Informe um telefone válido.',
  },
  password: {
    password: 'Senha',
    repeatPassword: 'Repetir Senha',
    minimumCharacterPass: 'Pelo menos 8 caracteres.',
    specialCharacter: 'Pelo menos 1 caractere especial.',
    oneNumber: 'Pelo menos 1 número.',
    requiredPass: 'É necessário informar uma senha.',
    minimumCharacterPassError: 'A senha precisa conter pelo menos 8 caracteres.',
    specialCharacterError: 'A senha precisa conter pelo menos 1 caractere especial.',
    oneNumberError: 'A senha precisa conter pelo menos 1 número.',
    differentPass: 'As senhas informadas são diferentes.',
  },
  cep: {
    cep: 'CEP',
    city: 'CIDADE',
    address: 'ENDEREÇO',
    neighborhood: 'BAIRRO',
    state: 'ESTADO',
    stateHint: 'Somente forma abreviada (máx. 4 caracteres)',
    number: 'Nº',
    complement: 'COMPLEMENTO',
    cepRequired: 'É necessário informar um cep.',
    numberRequired: 'É necessário informar um número.',
    onlyNumber: 'O Nº deve conter apenas números.',
    addressRequired: 'É necessário informar a localidade e o endereço.',
    neighborhoodRequired: 'É necessário informar um bairro.',
    stateRequired: 'É necessário informar um estado.',
  },
  guardian: {
    firstName: 'Nome do responsável',
    surname: 'Sobrenome do responsável',
    cpf: 'CPF do responsável',
    email: 'E-mail do responsável',
    birthDate: 'Data de nascimento do responsável',
    phone: 'Celular do responsável',
    degree: 'Grau de parentesco',
    verificationCode: 'Insira o código de verificação',
    codeSent: 'Um código foi enviado ao e-mail do responsável!',
    firstNameRequired: 'É necessário informar o nome do responsável.',
    surnameRequired: 'É necessário informar o sobrenome.',
    cpfInvalid: 'Informe um CPF válido.',
    phoneRequired: 'É necessário informar um telefone.',
    phoneInvalid: 'Informe um telefone válido.',
    genderRequired: 'É necessário informar o gênero.',
    degreeRequired: 'É necessário informar o grau de parentesco.',
    birthDateInvalid: 'Informe uma data de nascimento válida para o responsável.',
    ageRequired: 'O responsável precisa ser maior de 18 anos.',
    emailInvalid: 'É necessário um E-mail válido.',
    codeInvalid: 'Código informado incorreto.',
  },
  searchUser: {
    cpfOrEmail: 'CPF ou E-mail',
    guardianName: 'Nome do responsável',
  },
  gnv: {
    fanTypeTitle: 'VOCÊ É ATLETICANO?',
    fanTypeDescription: 'Selecione uma opção para continuar com o seu cadastro no Galo ID.',
    fanTypeAtleticano: 'SOU ATLETICANO',
    fanTypeVisitante: 'NÃO SOU ATLETICANO',
    benefitsTitle: 'Tem certeza que deseja prosseguir?',
    benefitsDescription: 'Ao desmarcar, você perderá acesso aos benefícios exclusivos:',
    benefitsCta: 'O plano GNV da Massa é 100% gratuito!',
    benefitsConfirmWithPlan: 'QUERO SER GNV',
    benefitsConfirmWithoutPlan: 'CONTINUAR SEM',
    benefits: [
      'Preços exclusivos em ingressos',
      'Acesso antecipado às vendas',
      'Descontos em produtos oficiais',
      'Bônus de moedas no Superapp',
      'Cashback em compras de parceiros',
      'Promoções e sorteios exclusivos',
    ],
    under18Title: 'ATENÇÃO',
    under18Message:
      'Ops! A oferta do plano GNV da Massa gratuito é apenas para maiores de 18 anos. Vamos seguir o seu cadastro sem a atribuição do plano.',
  },
  foreignUnder18: {
    title: 'ATENÇÃO',
    message:
      'Não é permitido o cadastro de menores como estrangeiro. Contate o suporte em contato@galonaveia.com.br para mais informações.',
  },
}
